module.exports = { "default": require("core-js/library/fn/array/of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/array/of.js
// module id = 764
// module chunks = 14